import React from 'react'
import { Link } from 'gatsby'
import classnames from 'classnames'
import { withMainContext } from './menuContainer'
import { PAGES } from './constants'
import '../styles/nav-banner.less'

class NavigationBanner extends React.Component {
  render() {
    const { to, getColorClassForPage, screensaverActive } = this.props 
    const link = `/${to}`
    const text = `${to}`
    const color = getColorClassForPage(to)
    const containerCls = classnames({ 'navigation-banner': true, [color]: true, 'transition-background-color': screensaverActive })
    return null
    // return (
    //   <div className={containerCls}>
    //     <Link to={link}>{text}</Link>
    //   </div>  
    // )  
  }
}

export default withMainContext((context, props) => ({
  getColorClassForPage: context.action.getColorClassForPage,
  screensaverActive: context.screensaverActive
}))(NavigationBanner)